import { Component, OnInit,Input } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { ApiService } from '../../../../../../Services/api.service';
import { StorageService } from '../../../../../../Services/storage.service';
import { SweetAlert } from '../../../../../../Services/sweetalet.service';
declare const Swal;

@Component({
  selector: 'app-unassign-vehicle',
  templateUrl: './unassign-vehicle-component.html',
  
})
export class UnAssignVehicleComponent implements OnInit {
  @Input() _activeMenu: string = '';
  @Input() public set search(val: string) {
    this.onSearchChange(val);
  }

  public vendorID = '';
  public manageData = [];
  public routerLinkStr = '';

  public filterTable:boolean = true;
  public enableTable:boolean = false;
  isClicked: boolean = false;
  /* Pagination */
  public showPagination:boolean = true;
  public paginationData = {
    page:1,
    limit:10,
    totalPage:1,
  };

  /* filters */
  searchChangeObserver: any;
  public searchInputValue = '';
  public branchNameMap: { [key: string]: string } = {};
  public vehicleBranchMap: { [key: string]: string } = {};

  public cols = [
    { key: '#', display: '#' },
    { key: 'vehRegNo', display: 'Reg no',config:{ isVehicle:true,}, headerConfig:{ isDefault: true}},
    { key: 'branch', display: 'Branch' },
    { key: 'model', display: 'Model',config: { isAttendance: true, } },
    { key: 'capacity', display: 'Capacity' },
    // { key: 'action', display: 'Action', 
    //   config: { 
    //     isAction: true,
    //     actions: [
    //       { display: 'Update', color: 'primary', icon: 'Edit', class:'fs-13' },
    //       { display: 'Delete', color: 'warn', icon: 'Delete' },
    //     ]
    //   }
    // }
  ];
  public tableData = [];
  public unAssignVehitableData=[];
  
  constructor(
    public storage: StorageService, 
    public router: Router,
    public route: ActivatedRoute,
    public api: ApiService,
    public swal :SweetAlert,
) {
  this.route.paramMap.subscribe((params: any) => {
    this.vendorID=params.params.vendorID;
  });
}

  ngOnInit(): void {
    this.routerLinkStr = `/organization/transport-manager/information/manage/manage-vehicle/${this.vendorID}`;
    this.getBranchList();
    this.getVehicleBranchList();
    setTimeout(()=>{ this.getManageList(); },1000);
  }

  getBranchList() {
    const obj = {
      orgID: this.storage.get('userInfo').orgID
    };

    this.api.transportManagerBranchList(obj).then((res: any) => {
      if (res?.status === 'success' && Array.isArray(res.data)) {
        this.branchNameMap = {};
        res.data.forEach(branch => {
          if (branch?.branchID) {
            this.branchNameMap[String(branch.branchID)] = branch.branchName || branch.branchID;
          }
        });
        this.remapTableBranchValues();
      }
    }).catch((err) => {
      console.log(err);
    });
  }

  getVehicleBranchList() {
    const obj = {
      vendorID: this.vendorID == null ? this.storage.get('vendorID_orgID').vendorID : this.vendorID,
    };

    this.api.transportManagerVehicleList(obj).then((res: any) => {
      if (res?.status === 'success' && Array.isArray(res.data)) {
        this.vehicleBranchMap = {};
        res.data.forEach(vehicle => {
          if (vehicle?.vehRegNo) {
            this.vehicleBranchMap[String(vehicle.vehRegNo)] = this.formatBranchTokens(
              vehicle?.branchName ?? vehicle?.branch ?? vehicle?.branchID
            );
          }
        });
        this.remapTableBranchValues();
      }
    }).catch((err) => {
      console.log(err);
    });
  }

  normalizeList(value: any): any[] {
    if (value === null || value === undefined || value === '') {
      return [];
    }

    if (Array.isArray(value)) {
      return value;
    }

    if (typeof value === 'string' && value.includes(',')) {
      return value.split(',').map(item => item.trim()).filter(item => item !== '');
    }

    return [value];
  }

  extractBranchToken(branch: any): string {
    if (branch === null || branch === undefined) {
      return '';
    }

    if (typeof branch === 'object') {
      return String(
        branch.branchID ??
        branch.branch ??
        branch.branchName ??
        branch.value ??
        branch.name ??
        ''
      ).trim();
    }

    return String(branch).trim();
  }

  formatBranchTokens(rawBranches: any): string {
    const branches = this.normalizeList(rawBranches)
      .map(branch => {
        const key = this.extractBranchToken(branch);
        return this.branchNameMap[key] || key;
      })
      .filter(branch => branch && branch !== 'undefined' && branch !== 'null');

    return branches.length > 0 ? branches.join(', ') : '';
  }

  formatBranchValue(item: any): string {
    const currentRowBranch = this.formatBranchTokens(item?.branchName ?? item?.branch ?? item?.branchID);
    if (currentRowBranch) {
      return currentRowBranch;
    }

    const vehicleBranch = item?.vehRegNo ? this.vehicleBranchMap[String(item.vehRegNo)] : '';
    if (vehicleBranch) {
      return vehicleBranch;
    }

    return '---';
  }

  remapTableBranchValues() {
    if (!Array.isArray(this.unAssignVehitableData) || this.unAssignVehitableData.length === 0) {
      return;
    }

    this.unAssignVehitableData = this.unAssignVehitableData.map(item => ({
      ...item,
      branch: this.formatBranchValue(item)
    }));
  }

  getManageList(page=1,limit=10,vehRegNo?){
    const obj = {
      vendorID: this.vendorID == null ? this.storage.get('vendorID_orgID').vendorID : this.vendorID,
      page:page,
      limit:limit,
    };
    if(vehRegNo) obj['vehRegNo'] = vehRegNo;
    
  
    this.api.transportManagerUnassignVehList(obj).then((res: any) => {
      if (res.status == 'success') {
        if(res.data){
          this.unAssignVehitableData = res.data.map((item)=>{
            let obj = { ...item};
            if(obj.model && obj.model=='loadVehicle') obj.model = 'Load Vehicle';
            return {
              ...obj,
              branch: this.formatBranchValue(obj)
            };
          })
        } 
        this.processPagination(res,obj);      
      }
      setTimeout(()=>{ this.enableTable = true;},200);
    }).catch((err) => {
      console.log(err);
    });
    

  }


  
  processPagination(data,req){
    this.enableTable = false;
    this.paginationData = {
      page:req.page,
      limit:req.limit,
      totalPage: this.getTotalCount(data.totCnt,req.limit),
    }
    this.enableTable = true;
  }

  getTotalCount(total,limit){
    let result:any = 1;  
    if(total/limit>0){
      result = total / limit;
      if(total % limit > 0) result++;
    }
    return Math.floor(result);
  }

  pagination(data){
    this.getManageList(data.page,data.limit,this.searchInputValue);
  }

     // search
     onSearchChange(searchValue: string) {

      searchValue = searchValue.trim().replace(/[^a-zA-Z0-9-_&, ]/g, '');
  
      if (!this.searchChangeObserver) {
        new Observable(observer => {
          this.searchChangeObserver = observer;
        }).pipe(debounceTime(500)) // wait 300ms after the last event before emitting last event
          .pipe(distinctUntilChanged()) // only emit if value is different from previous value
          .subscribe((term: any) => {
            // your code here
            this.searchInputValue = term;
            if(String(term).length==0) this.getManageList(1,this.paginationData.limit,term);
            else if(String(term).length>=2) this.getManageList(1,this.paginationData.limit,term);
            
          });
      }
  
      this.searchChangeObserver.next(searchValue);
    }


}
